import { render, staticRenderFns } from "./email-process-mapper.vue?vue&type=template&id=3f08a856&scoped=true&"
import script from "./js/email-process-mapper.js?vue&type=script&lang=js&"
export * from "./js/email-process-mapper.js?vue&type=script&lang=js&"
import style0 from "./email-process-mapper.vue?vue&type=style&index=0&id=3f08a856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f08a856",
  null
  
)

export default component.exports